import Chats from '@/pages/Chats'

export default {
    path: '/chats',
    name: 'Chats',
    component: Chats
}


// WEBPACK FOOTER //
// ./src/router/chats.js